// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Components Imports
import Notes from "../Notes";
import Catalog from "../Catalog";
import GoogleCatalog from "../GoogleCatalog";
import Collaborators from "../Collaborators";
import DocumentDetails from "../DocumentDetails";
import DocumentComponents from "../DocumentComponents";
import DynamicField from "../Document/DynamicField";
import AttachmentComponent from "../AttachmentComponent";
import QuickReview from "../QuickReview";
import Activity from "../Activity";

// Internal Imports
import { TOOLPANE, DOCUMENTS } from "../../constants";

// Actions Imports
import { QuotationActions, ToolbarActions } from "../../actions";
import { updateDocumentClickedComponentID } from "../../actions/DocumentActions";
import QuickReviewIcon from "../QuickReview/QuickReviewIcon";
// Destructuring
const { TOOLPANE_TTITLE, TOOLPANE_OPTIONS } = TOOLPANE;
const { updateToolPaneData } = QuotationActions;
const { DOC_COMPONENTS, NOTES, DYNAMIC_FIELDS, ATTACHMENTS } = TOOLPANE_TTITLE;
const { DOCUMENT_COMPONENT_TYPES } = DOCUMENTS;
const { updateAddComponentinToolbarAction } = ToolbarActions;

// Declaration
const TEMPLATE = "TEMPLATE";
const DOCUMENT = "DOCUMENT";

class ToolPaneWrapper extends Component {
  componentWillReceiveProps(nextProps) {
    /**
     * Reset the toolPane view to default when toggling between
     * lock and edit mode in document.
     */
    if (this.props.isLocked !== nextProps.isLocked) {
      this.props.updateToolPaneData(false, "");
    }
  }

  _onChangeView = newView => {
    const { view, isOpen, foundSignatureBlockStatus } = this.props;
    if (foundSignatureBlockStatus) {
      if (isOpen) {
        this.props.updateDocumentClickedComponentID(null, true, null);
      }
      this.props.updateAddComponentinToolbarAction("Signature");
    }
    if (view === newView && isOpen === true) {
      this.props.updateToolPaneData(false, "");
    } else {
      this.props.updateToolPaneData(true, newView);
      if (
        this.props.addComponentType === DOCUMENT_COMPONENT_TYPES.HEADER_FOOTER
      ) {
        this.props.updateAddComponentinToolbarAction(null);
      }
    }
  };

  _setToolBarView = view => {
    const { isSharedDocument, sharingHash, templateLockStatus } = this.props;
    switch (view) {
      case TOOLPANE_TTITLE.CATALOG:
        return <Catalog />;
      case TOOLPANE_TTITLE.COLLABORATORS:
        return <Collaborators {...this.props} />;
      case TOOLPANE_TTITLE.NOTES:
        return (
          <Notes
            {...this.props}
            isSharedDocument={isSharedDocument}
            sharingHash={sharingHash}
          />
        );
      case TOOLPANE_TTITLE.DOCUMENT_DETAILS:
        return <DocumentDetails />;
      case TOOLPANE_TTITLE.DOC_COMPONENTS:
        return (
          <DocumentComponents
            mode={this.props.mode}
            signatureWrapperRef={this.props.signatureWrapperRef}
          />
        );
      case TOOLPANE_TTITLE.DYNAMIC_FIELDS:
        return <DynamicField isLocked={templateLockStatus} />;
      case TOOLPANE_TTITLE.ACTIVITY:
        return <Activity {...this.props} />;
      case TOOLPANE_TTITLE.GOOGLE_CATALOG:
        return <GoogleCatalog isLocked={templateLockStatus} />;
      case TOOLPANE_TTITLE.ATTACHMENTS:
        return (
          <AttachmentComponent
            isSharedDocument={isSharedDocument}
            sharingHash={sharingHash}
          />
        );
      case TOOLPANE_TTITLE.QUICK_REVIEW:
        return <QuickReview />;
      default:
        return null;
    }
  };

  render() {
    const {
      isLocked,
      isOpen,
      page,
      view,
      isSharedDocument,
      showForm,
      templateStatus,
      mode,
      documentPageType,
      foundSignatureBlockStatus,
    } = this.props;
    let toolPaneOptions = TOOLPANE_OPTIONS[page] || [];
    // If it is a shared document page then, show only "Notes" toolpane
    if (isSharedDocument && documentPageType === "PERMA_SHARED_DOCUMENT") {
      toolPaneOptions = [];
    } else if (
      isSharedDocument &&
      documentPageType !== "PERMA_SHARED_DOCUMENT"
    ) {
      toolPaneOptions = TOOLPANE_OPTIONS[page]
        ? TOOLPANE_OPTIONS[page].filter(
            option => option.title === NOTES || option.title === ATTACHMENTS,
          )
        : [];
    }
    if (page) {
      return (
        <div className={`toolpanewrapper ${isOpen ? "is-open" : ""}`}>
          {isOpen && documentPageType !== "PERMA_SHARED_DOCUMENT" && (
            <div className={`toolpanewrapper-content ${view}`}>
              {this._setToolBarView(view)}
            </div>
          )}
          <div
            className={`toolpanewrapper-options ${
              isSharedDocument ? "shareddocument-toolpanewrapper-options" : ""
            }`}>
            {toolPaneOptions.map(option => {
              // cases to hide DOC_COMPONENTS icon
              if (
                option.title === DOC_COMPONENTS ||
                option.title === DYNAMIC_FIELDS
              ) {
                if (
                  mode === DOCUMENT &&
                  (isLocked || showForm) &&
                  !foundSignatureBlockStatus
                ) {
                  return null;
                }
                if (mode === TEMPLATE && templateStatus !== "DRAFT") {
                  return null;
                }
              }
              if (!(isLocked && option.hideOnViewMode)) {
                return (
                  <div
                    data-test={`toolpanewrapper-apps-${option.title}-icon`}
                    key={option.title}
                    className={`toolpanewrapper-apps ${
                      option.title === view && isOpen ? "active" : null
                    }`}
                    id={`${option.title}-icon`}
                    onClick={() => this._onChangeView(option.title)}
                    tabIndex="0"
                    onKeyDown={() => {}}
                    role="button">
                    {option.title === "quick-review" ? (
                      <div className={`toolpanewrapper-ico ${option.title}`}>
                        <QuickReviewIcon
                          active={option.title === view && isOpen}
                        />
                        <div className="option-title">
                          {option.toolTipLabel}
                        </div>
                      </div>
                    ) : (
                      <div className={`toolpanewrapper-ico ${option.title}`}>
                        {[DOC_COMPONENTS, DYNAMIC_FIELDS].includes(
                          option.title,
                        ) ? (
                          <FontAwesomeIcon icon={["fas", `${option.ico}`]} />
                        ) : (
                          <FontAwesomeIcon icon={["fad", `${option.ico}`]} />
                        )}
                        <div className="option-title">
                          {option.toolTipLabel}
                        </div>
                      </div>
                    )}
                  </div>
                );
              }
              return <div key={option.title} />;
            })}
          </div>
        </div>
      );
    }
    return <div />;
  }
}

const mapStateToProps = (state, props) => {
  const { mode, showForm } = props;
  const { isOpen, page, view, addComponentType } = state.ToolPaneStore;
  const { document: { isLocked, stage } = {}, content } = state.DocumentStore;

  /* This code is responsible for handling Dynamic field with Signature */
  let foundSignatureBlockStatus;
  if (content && content.sections && content.sections.length > 0) {
    const found = content.sections.find(
      element => element.type === "Signature",
    );
    if (found && showForm && stage === "DRAFT") {
      foundSignatureBlockStatus = true;
    }
  }
  let templateLockStatus = false;
  let templateStatus;
  if (mode === TEMPLATE) {
    const { template } = state.TemplateStore;
    templateStatus = template.status;
    templateLockStatus = templateStatus !== "DRAFT";
  }
  return {
    isLocked,
    isOpen,
    page,
    view,
    addComponentType,
    templateStatus,
    templateLockStatus,
    content,
    foundSignatureBlockStatus,
    stage,
  };
};

const mapDispatchToProps = {
  updateToolPaneData,
  updateAddComponentinToolbarAction,
  updateDocumentClickedComponentID,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ToolPaneWrapper);



// WEBPACK FOOTER //
// ./src/components/ToolPaneWrapper/ToolPaneWrapper.js